import Joi from "joi"

export default Joi.object({
	firstname: Joi.string().min(1).max(30).required().messages({
		"string.base": `Le prénom doit être un texte`,
		"string.empty": `Saisissez votre prénom`,
		"string.min": `Le prénom doit avoir au moins {#limit} lettres`,
		"string.max": `Le prénom doit avoir au plus {#limit} lettres`,
		"any.required": "Saisissez votre prénom",
	}),

	lastname: Joi.string().min(1).max(30).required().messages({
		"string.base": `Le nom doit être un texte`,
		"string.empty": `Saisissez votre nom de famille`,
		"string.min": `Le nom doit avoir au moins {#limit} lettres`,
		"string.max": `Le nom doit avoir au plus {#limit} lettres`,
		"any.required": "Saisissez votre nom de famille",
	}),

	email: Joi.string()
		.email({ minDomainSegments: 2, tlds: { allow: ["com", "fr", "io"] } })
		.messages({
			"string.base": `L'email n'a pas le bon format (un texte)`,
			"string.empty": `Saisissez votre email`,
			"string.email": `L'email n'a pas le bon format (.com ou .fr)`,
			"any.required": "Saisissez votre email",
		}),

	phone: Joi.string()
		.pattern(/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/i)
		.required()
		.messages({
			"string.base": `Le numéro de telephone n'a pas le bon format`,
			"string.empty": `Saisissez votre numéro de téléphone`,
			"string.pattern.base": `Seuls les numéro français sont acceptés`,
			"any.required": "Saisissez votre numéro de téléphone",
		}),

	shipping_address: Joi.any(),
	manual_shipping_address: Joi.string().allow(""),
	manual_shipping_postal_code: Joi.string().allow(""),
	manual_shipping_city: Joi.string().allow(""),
	manual_shipping_additional_address_line: Joi.string().allow(""),
	// .invalid(null, {}).required().messages({
	// 	"any.invalid": `Saisissez votre adresse de facturation`,
	// 	"any.required": `Saisissez votre adresse de facturation`,
	// }),
	//manual_shipping address/postal_code/city or shipping_address required
	// address or manual_billing
	address: Joi.any(),
	manual_billing_address: Joi.string().allow(""),
	manual_billing_postal_code: Joi.string().allow(""),
	manual_billing_city: Joi.string().allow(""),
	manual_billing_additional_address_line: Joi.string().allow(""),

	prescriber: Joi.any() /* .invalid(null, {}).required().messages({
        "any.invalid": `Saisissez le nom de votre prescripteur`,
        "any.required": `Saisissez le nom de votre prescripteur`,
    }) */,

	prescription: Joi.any(),
	prescription_bis: Joi.any(),
	prescription_ter: Joi.any(),
	surgery_date: Joi.alternatives().try(Joi.date().min("now"), Joi.valid("")).messages({
		"alternatives.any": `Le formulaire n'accepte pas les interventions passées`,
		"date.min": `Le formulaire n'accepte pas les interventions passées`,
		"date.base": `Le formulaire n'accepte pas les interventions passées`,
	}),
	intervention_zone: Joi.string().valid("épaule", "hanche", "genou", "cheville", "pied", "jambe entière", "").messages({
		"any.only": `Sélectionnez une zone valide`,
	}),
	accept: Joi.string().valid(true).required().messages({
		"any.only": ``, // error in front outside input
		"any.required": ``, // error in front outside input
	}),
	toggle: Joi.string().allow(null, ""),
	toggle_manual_shipping_address: Joi.boolean(),
	toggle_manual_billing_address: Joi.boolean(),
	toggle_prescription_bis: Joi.boolean(),
	toggle_prescription_ter: Joi.boolean(),
})
